import { IUseTranslation, TranslateProvider } from "@helium10/re-core";
import LocalizedStrings from "localized-strings";
import { createContext, PropsWithChildren, useContext } from "react";

import en from "./translates/en.json";
type ILanguage = typeof en;

const strings = new LocalizedStrings({ en }, { logsEnabled: false });

export const ContainerTranslateProvider = ({ children }: PropsWithChildren) => {
  return (
    <TranslateProvider strings={strings} TranslateContext={TranslateContext}>
      {children}
    </TranslateProvider>
  );
};

const TranslateContext = createContext<IUseTranslation<ILanguage> | null>(null);

export const useTranslation = (): IUseTranslation<ILanguage> => {
  const context = useContext(TranslateContext);
  if (!context) {
    throw new Error("[Translation] The provider is not defined");
  }
  return context;
};
